module.exports = "/static/assets/19725087656ad7fa8228060ca86306a7.png";